import { CallType, CallStatus } from '@/types';

export interface CallReportServiceGetInfoParams {
    startDate: string;
    endDate: string;
    type: CallType | null;
    status: CallStatus | null;
    user: number | null;
    userLabel: number | null;
    number: string | null;
    serviceTimeRange: string | null;
}
